import { BaseEntity, BaseSearchForm } from 'entities'
import { Sample, SampleStatus } from './sample'

export type SampleStatusLog = BaseEntity & {
    before?: SampleStatus
    after?: SampleStatus
    date?: string
    sample?: Sample
    sampleId?: string
    beforeAfter?: SampleStatusLogType
    isForceChange?: boolean
}

export type SampleStatusLogForm = SampleStatusLog

export type SampleStatusLogSearchForm = BaseSearchForm &
    SampleStatusLog & {
        createdAtAfter?: string
        createdAtBefore?: string
        isStandard?: boolean
        isTest?: boolean
    }

export type SampleStatusLogType =
    | 'None__DRAFT'
    | 'DRAFT__INPUTTED'
    | 'INPUTTED__INSPECTED'
    | 'WAREHOUSED__RNA_EXTRACTED'
    | 'RNA_EXTRACTED__DNA_SYNTHESIZED'
    | 'PCR_READY__COMPLETED'
    | 'COMPLETED__SENT'
    | 'PCR_READY__WAREHOUSED'
    | 'PCR_READY__RNA_EXTRACTED'
    | 'PCR_READY__DNA_SYNTHESIZED'

export const sampleStatusLogLocaleJa: Record<SampleStatusLogType, string> = {
    None__DRAFT: '入庫',
    DRAFT__INPUTTED: '入力',
    INPUTTED__INSPECTED: '確認',
    WAREHOUSED__RNA_EXTRACTED: 'RNA抽出・精製',
    RNA_EXTRACTED__DNA_SYNTHESIZED: 'cDNA合成',
    PCR_READY__COMPLETED: 'qPCR Run',
    COMPLETED__SENT: '結果票送付',
    PCR_READY__WAREHOUSED: 'RNA再精製',
    PCR_READY__RNA_EXTRACTED: 'cDNA再合成',
    PCR_READY__DNA_SYNTHESIZED: 'qPCR再測定',
}
